import VendorIndex from "@/components/flux_oms/vendor/VendorIndex.vue";
import VendorUpload from "@/components/flux_oms/vendor/VendorUpload.vue";
import VendorCreate from "@/components/flux_oms/vendor/VendorCreate.vue";
import VendorDetail from "@/components/flux_oms/vendor/VendorDetail.vue";
import VendorUpdate from "@/components/flux_oms/vendor/VendorUpdate.vue";

let routesVendor= [
    {
        path: '',
        meta: {
            title: "Vendor ",
        },
        name: "VendorIndex",
        component: VendorIndex
    },
    {
        path: 'create',
        meta: {
          title: "Vendor Create",
        },
        name: "VendorCreate",
        component: VendorCreate
    },

    {
        path: 'upload',
        meta: {
          title: "Vendor ",
        },
        name: "VendorUploads",
        component: VendorUpload
    },

    {
        path: 'detail/:id',
        meta: {
          title: "Vendor ",
        },
        name: "VendorDetail",
        component: VendorDetail
    },


    {
      path: 'edit/:id',
      meta: {
        title: "Vendor Update",
      },
      name: "VendorUpdate",
      component: VendorUpdate
  },
     
   
     
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Master SKU Edit",
    //     },
    //     name: "MasterSKUEdit",
    //     component: MasterSKUEdit
    // },
    
]

export default routesVendor
  